const channerAdmin = resolve => require(["@/pages/channerAdmin/index.vue"], resolve);
const basicConfig = resolve => require(["@/pages/channerAdmin/basicConfig.vue"], resolve);
const interestsConfig = resolve => require(["@/pages/channerAdmin/interestsConfig.vue"], resolve);
export default [
  /****************会员管理***************/
  {
    path: "/channerAdmin",
    name: "渠道商管理",
    component: channerAdmin,
  },{
    path: "/basicConfig",
    name: "基础配置",
    component: basicConfig,
  },{
    path: "/interestsConfig",
    name: "权益配置",
    component: interestsConfig,
  }
];
